<template>
  <div class="alter-user-name-main" :style="iosOrAndroidStyle">
    <w-navbar
        :icon="'iconchevron-left'"
        nav_title="昵称修改"
        @mobileLeftBtn="leftBtnClick"
        v-show="iosOrAndroidShow"
    />

    <div class="alter-input margin-t-10">
      <cube-input v-model="name" :maxlength="20" placeholder="请输入您的昵称"></cube-input>
      <div class="length">{{name.length}}/20</div>
    </div>

    <button :class="[name.length ? 'active' : '']" @click="save">保存</button>
  </div>
</template>
<script>
	import WNavbar from '@/components/global/w-navbar'
	import { userMixin } from '@/assets/js/mixin/user'
	import { envMixin } from '@/assets/js/mixin/global'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'AlterUserName',
		mixins: [ userMixin, componentsMixin, envMixin ],
		components: {
			WNavbar
		},
		data () {
			return {
				name: ''
			}
		},
    mounted () {
      if (this.$route.query.username) {
        this.name = this.$route.query.username;
      }
    },
		methods: {

			leftBtnClick () {
				this.$router.back()
			},

			async save () {
				if (!this.name.length) return false
				let res = await this.$api.online.createBasicInfo({ username: this.name }, this.cvAccountToken)
				if (res.code === 1000) {
					this.showToast('修改成功')
					setTimeout(() => {
						this.leftBtnClick()
					}, 1000)
				} else {
					this.showToast('修改失败')
				}
			}
		},
	}
</script>
<style lang="scss" scoped>
  .alter-user-name-main {
    height: calc(100vh);
    background: #F9F9F9;
    padding-top: 44px;
    overflow: hidden;
    .margin-t-10 {
      margin-top: 10px;
    }
    .alter-input {
      width: 100%;
      height: 55px;
      background: #fff;
      position: relative;
      display: flex;
      align-items: center;
    }
    .length {
      height: 55px;
      line-height: 55px;
      position: absolute;
      top: 0;
      right: 14px;
      z-index: 3;
      color: #BCBCBC;
    }
    button {
      width: 343px;
      height: 42px;
      background: #CFCFCF;
      border: none;
      border-radius: 4px;
      position: fixed;
      bottom: 18px;
      left: 16px;
      font-size: 16px;
      color: #fff;
      &.active {
        background: #FF4F4C;
        color: #fff;
      }
    }
  }
</style>
<style lang="scss">
  .alter-user-name-main {
    .cube-input {
      width: 100% !important;
      border: none !important;
    }
    .cube-input_active input {
      border: none !important;
      outline: none !important;

    }
    .cube-input input,
    .cube-input::after {
      border: none !important;
    }
  }
</style>
